import { BuildingIcon, FeaturedIcons, useTheme } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import {
  ExplorerAccessibleSectionSerializer,
  ExplorerViewCompanyAffidavitsSerializer,
} from '@bcba/serializers';
import { useMemo } from 'react';
import { useUserContext } from '../../contexts/UserContext';
import { DigitalDossierAside } from '../DigitalDossier/shared/DigitalDossierAside';
import { ReadOnlyProductiveAffidavitsSection } from './components/ReadOnlyProductiveAffidavitsSection';
import { ReadOnlyStorageAffidavitsSection } from './components/ReadOnlyStorageAffidavitsSection';
import { RestrictedSection } from './components/RestrictedSection';

interface Props {
  affidavitsInformation: ExplorerAccessibleSectionSerializer<ExplorerViewCompanyAffidavitsSerializer>;
}

export const SharedAffidavitsSection = ({ affidavitsInformation }: Props) => {
  const { userHasPendingChanges, setUserHasPendingChanges } = useUserContext();
  const { t } = useTranslation();
  const theme = useTheme();
  const { hasAccess, data } = affidavitsInformation;

  const tabsData = useMemo(() => {
    if (!data) return [];
    const tabs = [
      {
        title: t('common.producers'),
        content: (
          <ReadOnlyProductiveAffidavitsSection
            data={data.productiveFacilities}
          />
        ),
        icon: <FeaturedIcons icon={BuildingIcon} variant="primary" size="sm" />,
      },
      {
        title: t('common.stockpiles'),
        content: (
          <ReadOnlyStorageAffidavitsSection data={data.storageFacilities} />
        ),
        icon: <FeaturedIcons icon={BuildingIcon} variant="primary" size="sm" />,
      },
    ];

    return tabs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!hasAccess) return <RestrictedSection />;

  return (
    <DigitalDossierAside
      tabsData={tabsData}
      theme={theme}
      hasUserPendingChanges={userHasPendingChanges}
      setUserHasPendingChanges={setUserHasPendingChanges}
    />
  );
};
